module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-disabled-ed6cdfdd81d68f90a4d2ecb548a10de3.png";